import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { CustomersApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

interface UseCustomerDeleteParams {
  userId: number;
  tenantId: number;
}

export const useCustomerDelete = () => {
  const accessToken = useAccessToken();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, isSuccess, isError, error } =
    useMutation({
      mutationFn: async ({ userId, tenantId }: UseCustomerDeleteParams) => {
        if (!accessToken) {
          throw new Error("Authentication token is required");
        }

        const service = createAuthenticatedApi(CustomersApi, accessToken);

        await service.apiUsersUserIdCustomerDelete({
          userId,
          xTenantID: tenantId,
        });

        return { userId };
      },
      onSuccess: ({ userId }) => {
        queryClient.invalidateQueries({
          queryKey: [QueryKeys.CustomerVaults, userId],
        });
      },
    });

  return { mutate, mutateAsync, isPending, isSuccess, isError, error };
};
